<template>
  <main-layout>
    <v-tabs
      v-model="currentPage"
      color="white"
      :slider-color="$vuetify.theme.primary"
      show-arrows
      @change="onChangeTabs"
    >
      <v-tab href="#audience-main" ripple>{{ $t('step_message.title') }}</v-tab>
      <v-tab href="#audience-history" ripple>{{ $t('step_message.history') }}</v-tab>
    </v-tabs>
    <component :is="currentPage"></component>
  </main-layout>
</template>

<script>
import AudienceMain from './AudienceMain.vue'
import AudienceHistory from './AudienceHistory.vue'

export default {
  components: { AudienceMain, AudienceHistory },
  data: () => ({
    currentPage: 'main'
  }),
  created() {
    if (this.$route.query) {
      let { page } = this.$route.query
      if (page) {
        const pageLists = ['audience-main', 'audience-history']
        const currentPage = pageLists.includes(page) ? page : 'audience-main'
        this.onChangeTabs(currentPage)
      } else {
        this.onChangeTabs('audience-main')
      }
    }
  },
  methods: {
    onChangeTabs(page) {
      console.log(page)
      if (!page) return
      try {
        this.$router
          .push({
            name: 'audience',
            path: '/audience',
            query: {
              page: page
            }
          })
          .catch(() => {})
        this.currentPage = page
      } catch (error) {}
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/stepmessage/index.vue